export var lettersAndNumbersMixin = {
    methods: {
        lettersAndNumbers: function lettersAndNumbers(evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 65 || charCode > 90) && (charCode !== 164 || charCode !== 165) && ( // ñ Ñ
            charCode < 97 || charCode > 122) && (charCode < 48 || charCode > 57) && charCode !== 32) {
                evt.preventDefault();
            } else {
                return true;
            }
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/mixins/letters-and-numbers.js
// module id = ./src/mixins/letters-and-numbers.js
// module chunks = 34